import {BaseAttribute, BaseAttributeOptions} from './BaseAttribute';

export type NotFetchedAttributeOptions = BaseAttributeOptions;

// Attribute for columns materialized only in the UI
export class NotFetchedAttribute extends BaseAttribute {
  constructor(options: NotFetchedAttributeOptions = {}) {
    super(options);
  }

  // Input type that is used if attribute is used in edit mode
  get inputType(): string {
    return 'not_fetched';
  }

  // The data is calculated from the other data returned by the query: we do not fetch anything for this attribute
  get selectString(): string {
    return '';
  }

  /** Converts the value from the database to a value that can be used in the UI */
  toLocalValue(item: Record<string, unknown>): unknown {
    if (this.transform) return this.transform(item);
    return item;
  }
}
